/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * События устройств (домофоны, калитки, шлагбаумы). События оповещения
 */

/**
 * Тип проигрывания.
 */
export enum PlayStartTaskPlayType {
  /**
   * Значение не указано
   */
  PLAY_TYPE_UNKNOWN = "PLAY_TYPE_UNKNOWN",
  /**
   * Только на аналоговые трубки
   */
  HANDSET_ONLY = "HANDSET_ONLY",
  /**
   * Только на динамик домофона
   */
  SPEAKER_ONLY = "SPEAKER_ONLY",
  /**
   * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
   */
  HANDSET_AND_SPEAKER = "HANDSET_AND_SPEAKER",
  /**
   * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
   */
  SPEAKER_AND_HANDSET = "SPEAKER_AND_HANDSET",
}
/**
 * Тип проигрывания.
 */
export type PlayStartTaskPlayTypeResponseEnum = keyof typeof PlayStartTaskPlayType
/**
 * Тип проигрывания.
 */
export type PlayStartTaskPlayTypeRequestEnum = Exclude<PlayStartTaskPlayTypeResponseEnum, "PLAY_TYPE_UNKNOWN">;

/**
 * Тип проигрывания.
 */
export enum PrepareStartTaskPlayType {
  /**
   * Значение не указано
   */
  PLAY_TYPE_UNKNOWN = "PLAY_TYPE_UNKNOWN",
  /**
   * Только на аналоговые трубки
   */
  HANDSET_ONLY = "HANDSET_ONLY",
  /**
   * Только на динамик домофона
   */
  SPEAKER_ONLY = "SPEAKER_ONLY",
  /**
   * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
   */
  HANDSET_AND_SPEAKER = "HANDSET_AND_SPEAKER",
  /**
   * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
   */
  SPEAKER_AND_HANDSET = "SPEAKER_AND_HANDSET",
}
/**
 * Тип проигрывания.
 */
export type PrepareStartTaskPlayTypeResponseEnum = keyof typeof PrepareStartTaskPlayType
/**
 * Тип проигрывания.
 */
export type PrepareStartTaskPlayTypeRequestEnum = Exclude<PrepareStartTaskPlayTypeResponseEnum, "PLAY_TYPE_UNKNOWN">;

/**
 * Команда на старт проигрывания файла через домофон.
 * Очередь key.device.alert.play_start
 */
export type PlayStartTaskRequestDto = {
  /**
   * Идентификатор запроса.
   * # Тип: Guid
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ссылка на звуковой файл для проигрывания.
   * Файл должен лежать на внутреннем хранилище.
   * # Диапазон: 7..100
   */
  soundFileUri: string
  /**
   * Сетевой адрес.
   * # Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
   */
  ipAddress: string
  /**
   * Сетевой порт.
   * # Диапазон: 0..65535
   */
  port?: number | null
  /**
   * Модель устройства.
   * # Диапазон: 2..100
   */
  model: string
  /**
   * Длительность воспроизведения такта в секундах.
   * Такт включает в себя проигрывание файла на трубках или на динамике.
   * # Диапазон: 0..65536
   */
  tactPlayDuration: number
  /**
   * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
   * # Диапазон: 0..65536
   */
  tactRepeatCount: number
  /**
   * Количество повторов заданного количества тактов, где умолчание=0 - это один повтор.
   * # Диапазон: 0..65536
   */
  playRepeatCount: number
  /**
   * Тип проигрывания
   */
  playType: PlayStartTaskPlayTypeRequestEnum
  /**
   * Логин.
   * # Диапазон: 0..100
   */
  login?: string | null
  /**
   * Пароль.
   * # Диапазон: 0..100
   */
  password?: string | null
}
/**
 * Команда на старт проигрывания файла через домофон.
 * Очередь key.device.alert.play_start
 */
export type PlayStartTaskResponseDto = {
  /**
   * Идентификатор запроса.
   * # Тип: Guid
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ссылка на звуковой файл для проигрывания.
   * Файл должен лежать на внутреннем хранилище.
   * # Диапазон: 7..100
   */
  soundFileUri: string
  /**
   * Сетевой адрес.
   * # Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
   */
  ipAddress: string
  /**
   * Сетевой порт.
   * # Диапазон: 0..65535
   */
  port: number | null
  /**
   * Модель устройства.
   * # Диапазон: 2..100
   */
  model: string
  /**
   * Длительность воспроизведения такта в секундах.
   * Такт включает в себя проигрывание файла на трубках или на динамике.
   * # Диапазон: 0..65536
   */
  tactPlayDuration: number
  /**
   * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
   * # Диапазон: 0..65536
   */
  tactRepeatCount: number
  /**
   * Количество повторов заданного количества тактов, где умолчание=0 - это один повтор.
   * # Диапазон: 0..65536
   */
  playRepeatCount: number
  /**
   * Тип проигрывания
   */
  playType: PlayStartTaskPlayTypeResponseEnum
  /**
   * Логин.
   * # Диапазон: 0..100
   */
  login: string | null
  /**
   * Пароль.
   * # Диапазон: 0..100
   */
  password: string | null
}
/**
 * Команда на прекращение проигрывания файла через домофон.
 * Очередь key.device.alert.play_stop
 */
export type PlayStopTaskRequestDto = {
  /**
   * Идентификатор запроса.
   * # Тип: Guid
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Сетевой адрес.
   * # Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
   */
  ipAddress: string
  /**
   * Сетевой порт.
   * # Диапазон: 0..65535
   */
  port?: number | null
  /**
   * Модель устройства.
   * # Диапазон: 2..100
   */
  model: string
  /**
   * Логин.
   * # Диапазон: 0..100
   */
  login?: string | null
  /**
   * Пароль.
   * # Диапазон: 0..100
   */
  password?: string | null
}
/**
 * Команда на прекращение проигрывания файла через домофон.
 * Очередь key.device.alert.play_stop
 */
export type PlayStopTaskResponseDto = {
  /**
   * Идентификатор запроса.
   * # Тип: Guid
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Сетевой адрес.
   * # Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
   */
  ipAddress: string
  /**
   * Сетевой порт.
   * # Диапазон: 0..65535
   */
  port: number | null
  /**
   * Модель устройства.
   * # Диапазон: 2..100
   */
  model: string
  /**
   * Логин.
   * # Диапазон: 0..100
   */
  login: string | null
  /**
   * Пароль.
   * # Диапазон: 0..100
   */
  password: string | null
}
/**
 * Команда на подготовку и старт проигрывания файла через домофон.
 * Очередь key.device.alert.prepare_start
 */
export type PrepareStartTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Ссылка на звуковой файл для проигрывания.
   * Файл должен лежать на внутреннем хранилище.
   * # Диапазон: 2..100
   */
  soundFileUri: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Длительность воспроизведения такта в секундах.
   * Такт включает в себя проигрывание файла на трубках или на динамике.
   * # Диапазон: 0..65536
   */
  tactPlayDuration: number
  /**
   * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
   * # Диапазон: 0..65536
   */
  tactRepeatCount: number
  /**
   * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
   * # Диапазон: 0..65536
   */
  playRepeatCount: number
  /**
   * Тип проигрывания
   */
  playType: PrepareStartTaskPlayTypeRequestEnum
}
/**
 * Команда на подготовку и старт проигрывания файла через домофон.
 * Очередь key.device.alert.prepare_start
 */
export type PrepareStartTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Ссылка на звуковой файл для проигрывания.
   * Файл должен лежать на внутреннем хранилище.
   * # Диапазон: 2..100
   */
  soundFileUri: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Длительность воспроизведения такта в секундах.
   * Такт включает в себя проигрывание файла на трубках или на динамике.
   * # Диапазон: 0..65536
   */
  tactPlayDuration: number
  /**
   * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
   * # Диапазон: 0..65536
   */
  tactRepeatCount: number
  /**
   * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
   * # Диапазон: 0..65536
   */
  playRepeatCount: number
  /**
   * Тип проигрывания
   */
  playType: PrepareStartTaskPlayTypeResponseEnum
}
/**
 * Команда на подготовку и прекращение проигрывания файла через домофон.
 * Очередь key.device.alert.prepare_stop
 */
export type PrepareStopTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Команда на подготовку и прекращение проигрывания файла через домофон.
 * Очередь key.device.alert.prepare_stop
 */
export type PrepareStopTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Команда на старт проигрывания файла через домофон.
   * Очередь key.device.alert.play_start
   */
  "PlayStartTask": {
    "kind": "class",
    "text": "Команда на старт проигрывания файла через домофон.\nОчередь key.device.alert.play_start",
    "fields": {
      /**
       * Идентификатор запроса.
       * # Тип: Guid
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ссылка на звуковой файл для проигрывания.
       * Файл должен лежать на внутреннем хранилище.
       * # Диапазон: 7..100
       */
      "soundFileUri": {
        "type": "string",
        "text": "Ссылка на звуковой файл для проигрывания.\nФайл должен лежать на внутреннем хранилище.\n# Диапазон: 7..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 7,
            "message": "Значение не входит в допустимый диапазон. Минимум: 7"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сетевой адрес.
       * # Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
       */
      "ipAddress": {
        "type": "string",
        "text": "Сетевой адрес.\n# Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/"
          }
        }
      },
      /**
       * Сетевой порт.
       * # Диапазон: 0..65535
       */
      "port": {
        "type": "google.protobuf.Int32Value",
        "text": "Сетевой порт.\n# Диапазон: 0..65535",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65535,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65535"
          },
        }
      },
      /**
       * Модель устройства.
       * # Диапазон: 2..100
       */
      "model": {
        "type": "string",
        "text": "Модель устройства.\n# Диапазон: 2..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Длительность воспроизведения такта в секундах.
       * Такт включает в себя проигрывание файла на трубках или на динамике.
       * # Диапазон: 0..65536
       */
      "tactPlayDuration": {
        "type": "int32",
        "text": "Длительность воспроизведения такта в секундах.\nТакт включает в себя проигрывание файла на трубках или на динамике.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
       * # Диапазон: 0..65536
       */
      "tactRepeatCount": {
        "type": "int32",
        "text": "Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество повторов заданного количества тактов, где умолчание=0 - это один повтор.
       * # Диапазон: 0..65536
       */
      "playRepeatCount": {
        "type": "int32",
        "text": "Количество повторов заданного количества тактов, где умолчание=0 - это один повтор.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Тип проигрывания
       */
      "playType": {
        "type": "PlayStartTask.PlayType",
        "text": "Тип проигрывания",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Логин.
       * # Диапазон: 0..100
       */
      "login": {
        "type": "google.protobuf.StringValue",
        "text": "Логин.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Пароль.
       * # Диапазон: 0..100
       */
      "password": {
        "type": "google.protobuf.StringValue",
        "text": "Пароль.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Команда на прекращение проигрывания файла через домофон.
   * Очередь key.device.alert.play_stop
   */
  "PlayStopTask": {
    "kind": "class",
    "text": "Команда на прекращение проигрывания файла через домофон.\nОчередь key.device.alert.play_stop",
    "fields": {
      /**
       * Идентификатор запроса.
       * # Тип: Guid
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Сетевой адрес.
       * # Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
       */
      "ipAddress": {
        "type": "string",
        "text": "Сетевой адрес.\n# Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/"
          }
        }
      },
      /**
       * Сетевой порт.
       * # Диапазон: 0..65535
       */
      "port": {
        "type": "google.protobuf.Int32Value",
        "text": "Сетевой порт.\n# Диапазон: 0..65535",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65535,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65535"
          },
        }
      },
      /**
       * Модель устройства.
       * # Диапазон: 2..100
       */
      "model": {
        "type": "string",
        "text": "Модель устройства.\n# Диапазон: 2..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Логин.
       * # Диапазон: 0..100
       */
      "login": {
        "type": "google.protobuf.StringValue",
        "text": "Логин.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Пароль.
       * # Диапазон: 0..100
       */
      "password": {
        "type": "google.protobuf.StringValue",
        "text": "Пароль.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Команда на подготовку и старт проигрывания файла через домофон.
   * Очередь key.device.alert.prepare_start
   */
  "PrepareStartTask": {
    "kind": "class",
    "text": "Команда на подготовку и старт проигрывания файла через домофон.\nОчередь key.device.alert.prepare_start",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ссылка на звуковой файл для проигрывания.
       * Файл должен лежать на внутреннем хранилище.
       * # Диапазон: 2..100
       */
      "soundFileUri": {
        "type": "string",
        "text": "Ссылка на звуковой файл для проигрывания.\nФайл должен лежать на внутреннем хранилище.\n# Диапазон: 2..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Длительность воспроизведения такта в секундах.
       * Такт включает в себя проигрывание файла на трубках или на динамике.
       * # Диапазон: 0..65536
       */
      "tactPlayDuration": {
        "type": "int32",
        "text": "Длительность воспроизведения такта в секундах.\nТакт включает в себя проигрывание файла на трубках или на динамике.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
       * # Диапазон: 0..65536
       */
      "tactRepeatCount": {
        "type": "int32",
        "text": "Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
       * # Диапазон: 0..65536
       */
      "playRepeatCount": {
        "type": "int32",
        "text": "Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Тип проигрывания
       */
      "playType": {
        "type": "PrepareStartTask.PlayType",
        "text": "Тип проигрывания",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Команда на подготовку и прекращение проигрывания файла через домофон.
   * Очередь key.device.alert.prepare_stop
   */
  "PrepareStopTask": {
    "kind": "class",
    "text": "Команда на подготовку и прекращение проигрывания файла через домофон.\nОчередь key.device.alert.prepare_stop",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Тип проигрывания.
   */
  "PlayStartTask.PlayType": {
    "kind": "enum",
    "text": "Тип проигрывания.",
    "values": {
      /**
       * Значение не указано
       */
      "PLAY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Только на аналоговые трубки
       */
      "HANDSET_ONLY": {
        "i": 1,
        "text": "Только на аналоговые трубки",
      },
      /**
       * Только на динамик домофона
       */
      "SPEAKER_ONLY": {
        "i": 2,
        "text": "Только на динамик домофона",
      },
      /**
       * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
       */
      "HANDSET_AND_SPEAKER": {
        "i": 3,
        "text": "Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона",
      },
      /**
       * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
       */
      "SPEAKER_AND_HANDSET": {
        "i": 4,
        "text": "Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки",
      },
    },
  },
  /**
   * Тип проигрывания.
   */
  "PrepareStartTask.PlayType": {
    "kind": "enum",
    "text": "Тип проигрывания.",
    "values": {
      /**
       * Значение не указано
       */
      "PLAY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Только на аналоговые трубки
       */
      "HANDSET_ONLY": {
        "i": 1,
        "text": "Только на аналоговые трубки",
      },
      /**
       * Только на динамик домофона
       */
      "SPEAKER_ONLY": {
        "i": 2,
        "text": "Только на динамик домофона",
      },
      /**
       * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
       */
      "HANDSET_AND_SPEAKER": {
        "i": 3,
        "text": "Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона",
      },
      /**
       * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
       */
      "SPEAKER_AND_HANDSET": {
        "i": 4,
        "text": "Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки",
      },
    },
  },
}